import { takeLatest, put } from 'redux-saga/effects';

import * as types from './types';

function* changeZoomLevel(action) {
  const { zoomLevelConfig } = action;
  const { startTime: startValue, endTime: endValue } = zoomLevelConfig;
  yield put({ type: types.UPDATE_ZOOM_LEVEL, zoomLevelConfig });
}

function* watchChangeZoomLevel() {
  yield takeLatest([types.CHANGE_ZOOM_LEVEL], changeZoomLevel);
}

export default [watchChangeZoomLevel];
